// Circus form tweaks — runtime fixes op Formie default-output.
//
// Agree-veld: Formie rendert de tekst in een <legend> en de checkbox in een
// aparte <label> (leeg). Klik op de legend toggelt de checkbox niet native.
// We delegeren click op legend naar de bijbehorende checkbox.

const bindAgreeLegendClick = () => {
  document.querySelectorAll(".fui-type-agree .fui-legend").forEach((legend) => {
    if (legend.dataset.agreeClickBound) return;
    legend.dataset.agreeClickBound = "1";
    legend.style.cursor = "pointer";
    legend.addEventListener("click", (e) => {
      const cb = legend
        .closest(".fui-type-agree")
        ?.querySelector('input[type="checkbox"]');
      if (!cb) return;
      // Alleen togglen als je niet op een link in de legend klikt (bv.
      // "privacybeleid"-link uit de agree-description).
      if (e.target.closest("a")) return;
      cb.checked = !cb.checked;
      cb.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bindAgreeLegendClick);
} else {
  bindAgreeLegendClick();
}
